import { AutoDismissFlag as AkAutoDismissFlag } from '@atlaskit/flag';
import { type ComponentProps } from 'react';

import { wrapComponentForChoreographer } from '../utils';

export const AutoDismissFlag =
	wrapComponentForChoreographer<ComponentProps<typeof AkAutoDismissFlag>>(AkAutoDismissFlag);
